module.exports = __webpack_public_path__ + "static/texture-mint-c3afc2f0109027bc9d3e9a851862fa44.png";